import RiwayatKTANPresenter from '../../../presenter/menu_anggota/riwayat-ktan-presenter.js';
import ImagePopUPInitiator from '../../../presenter/pop-up-presenter.js';




const RiwayatKTAN = {
	async render() {
		const view = `
		<!-- DataTales Example -->
		<div class="card mt-3">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between font-weight-bold text-primary">
                Riwayat Pengajuan KTAN
            </div>
            <div class="card-body ">
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" id="tableRiwayatKTAN" width="100%" cellspacing="0">
                        <thead>
                            <tr>
                                <th>Tanggal Pengajuan</th>
                                <th>PC </th>
                                <th>PD</th>
                                <th>Status PC</th>
                                <th>Status PD</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                            </tr>
                            <tr>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                            </tr>
                            <tr>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                                <td><div class="shimmer title-line"></div></td>
                            </tr>
                        </tbody>
                        <tfoot>
                            
                        </tfoot>
                        <tbody>
                        
                        
                        
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        `;
		return view;
	  },

	async afterRender() {
		await RiwayatKTANPresenter.init()
		await ImagePopUPInitiator.init()
	},

	_errorContent(container) {
		const errorContent = document.getElementById('main-content');
		errorContent.innerHTML = `<div class="msg-failed">
                             <span class="fa fa-pencil"></span>
                              <p class="center">Maaf , Aplikasi tidak dapat di tampilkan. Periksa kembali internet anda ya &#128522</p>
                             </div>`;
	},

};

export default RiwayatKTAN;